import { ShieldExclamationIcon } from "@heroicons/react/solid";
import { translate } from "utils";

interface EventRefundPolicyNoticeProps {
  enabled?: boolean;
  compact?: boolean;
  framed?: boolean;
}

function EventRefundPolicyNotice({
  enabled,
  compact = false,
  framed = true,
}: EventRefundPolicyNoticeProps) {
  if (!enabled) {
    return null;
  }

  if (!framed) {
    return (
      <section className={compact ? "mb-4 text-sm" : "mt-6 mb-6 text-sm"}>
        <p className={compact ? "text-base text-slate-500" : "text-slate-500"}>
          {translate("refundPolicy")}:
        </p>
        <p className="mt-1 whitespace-pre-line text-slate-900">
          {translate("eventNoRefundsPolicyText")}
        </p>
      </section>
    );
  }

  return (
    <section
      className={
        compact
          ? "mb-4 rounded-lg border border-amber-400 px-4 py-3 text-sm"
          : "mt-6 mb-6 rounded-lg border border-amber-400 px-4 py-3 text-sm"
      }
    >
      <details className="group sm:hidden">
        <summary className="flex cursor-pointer list-none items-start gap-2 [&::-webkit-details-marker]:hidden">
          <ShieldExclamationIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-500" />
          <span className="flex min-w-0 flex-1 items-center justify-between gap-2">
            <span className="font-semibold text-slate-900">
              {translate("refundPolicy")}
            </span>
            <span
              aria-hidden="true"
              className="icon-[material-symbols--keyboard-arrow-down-rounded] h-5 w-5 shrink-0 text-slate-400 transition-transform group-open:rotate-180"
            />
          </span>
        </summary>
        <p className="mt-2 whitespace-pre-line pl-6 text-slate-500">
          {translate("eventNoRefundsPolicyText")}
        </p>
      </details>
      <div className="hidden items-start gap-2 sm:flex">
        <ShieldExclamationIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-500" />
        <div>
          <p className="font-semibold text-slate-900">
            {translate("refundPolicy")}
          </p>
          <p className="mt-1 whitespace-pre-line text-slate-500">
            {translate("eventNoRefundsPolicyText")}
          </p>
        </div>
      </div>
    </section>
  );
}

export default EventRefundPolicyNotice;
